module.exports = __webpack_public_path__ + "static/4-ce93cc498d15176673937e3582647c14.jpg";